<template>
  <el-dialog
    :visible="visible"
    @close="$emit('update:visible', false)"
    width="400px"
  >
    <div
      slot="title"
      class="Diatitle"
    >
      <span>远程升级</span>
    </div>
    <el-select class="w__100" v-model="upgradeId" placeholder="请选择">
      <el-option
        v-for="item in list"
        :key="item.id"
        :label="item.fileName"
        :value="item.id">
      </el-option>
    </el-select>

    <template slot="footer">
      <el-button
        type="info"
        plain
        size="small"
        @click="$emit('update:visible', false)"
      >取消</el-button>
      <el-button
        type="primary"
        plain
        size="small"
        @click="commandDown"
      >确定</el-button>
    </template>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: undefined
    },
  },

  data() {
    return {
      list:[],
      upgradeId:null,
    };
  },
  watch:{
    visible:{
      handler(val){
        this.upgradeId = null;
        val && this.getDataList();
      },
      deep:true,
    }
  },
  mounted(){

  },
  methods: {
    async commandDown() {
      try {
        const params = {
          vehicleId:this.params.vehicleId,
          upgradeId:this.upgradeId
        };
        const { msg, code } = await this.$API.instructionIssuanceRemoteUpgrade(params);
        if(code !== 0) throw { msg };
        this.$msg({
          showClose: true,
          message: msg,
          type: "success"
        });
        this.$emit("update:visible", false);
      } catch (error) {
        console.log(error)
        this.$msg({
          showClose: true,
          message: error ? error.msg : "请输入正确字段",
          type: "error"
        });
      }
    },
    // 获取文件数据
    async getDataList(){
      try{
        const { code, msg, data } = await this.$API.getUpgradeFiles();
        if(code !== 0) throw { msg };
        console.log(data);
        this.list = data;
      }catch({ msg }){
        this.$msg({
          type:'error',
          message:msg,
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding: 30px 20px 10px 20px;
}
::v-deep .el-dialog__headerbtn {
  top: 12px !important;
}
.w__100{
  width: 100%;
 }
.Diatitle {
  width: 100%;
  height: 42px;
  background-color: #f6f6f6;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  span {
    padding: 0 20px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }
}
</style>
